export default {"src":"/_next/static/media/truck-shipped.5c204d5a.svg","height":286,"width":404};